import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Header from '../components/header';
import Footer from '../components/footer';
import Overlay from '../components/overlay';
import '../assets/styles/app.scss';

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = { overlayActive: false }
  }

  toggleOverlay = showOverlay => {
    this.setState(Object.assign(this.state, { overlayActive: showOverlay }));
  }

  disableOverlay = () => {
    this.setState(Object.assign(this.state, { overlayActive: false }));
  }

  render() {
    const { children, data } = this.props;

    return (
      <div>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            { name: 'description', content: 'marcos abreu - web architect/engineer portfolio' },
            { name: 'keywords', content: 'web, architect, engineer, portfolio, about, front-end, frontend, mobile, usability, ux, responsive, mobile-first, javascript, js, nodejs, web infrastructure, ssl, hosting, load-balancer' },
          ]}
        />
        <Header id="page-header"
          siteTitle={data.site.siteMetadata.title}
          onNavToggle={this.toggleOverlay}
          overlayActive={this.state.overlayActive } />
        <main id="main-content">
          {children()}
        </main>
        <Footer id="page-footer" />

        <Overlay isActive={this.state.overlayActive} onClick={this.disableOverlay} />
      </div>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.func,
};

export default Layout;

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js